import { render } from "./MediaflowBreaksDock.vue?vue&type=template&id=19a1dbbc"
import script from "./MediaflowBreaksDock.vue?vue&type=script&setup=true&lang=js"
export * from "./MediaflowBreaksDock.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Mediaflow/MediaflowBreaksDock.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "19a1dbbc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('19a1dbbc', __exports__)) {
    api.reload('19a1dbbc', __exports__)
  }
  
  module.hot.accept("./MediaflowBreaksDock.vue?vue&type=template&id=19a1dbbc", () => {
    api.rerender('19a1dbbc', render)
  })

}


export default __exports__